"use strict";var $TypeError=TypeError;module.exports=function(passed,required){if(passed<required)throw $TypeError("Not enough arguments");return passed};